import { ICalendarEvent, ICalendarQueryParams } from 'src/generated-types/calendarEvent'
import { queryClient } from 'src/query-client'
import { calendarQueryKeys } from 'src/query-keys'
import { fetcher, useGet } from './reactQuery'

const calendarBaseURL = (customerId: EntityId) => `customers/${customerId}/calendar`

export const calendarEndpoints = {
  globalCalendar(customerId: EntityId) {
    return calendarBaseURL(customerId)
  },
}

export const useGetGlobalCalendar = (customerId: EntityId, queries: ICalendarQueryParams) =>
  useGet<Array<ICalendarEvent>>(
    calendarEndpoints.globalCalendar(customerId),
    { ...queries },
    {
      queryKey: calendarQueryKeys.GET_GLOBAL_CALENDAR(customerId, { ...queries }),
      enabled: !!customerId && !!queries.from && !!queries.to,
    },
  )

// Warm the cache for an adjacent month so navigation feels instant. The query key matches
// useGetGlobalCalendar exactly, so the subsequent navigation is a cache hit.
export const prefetchGlobalCalendar = (customerId: EntityId, queries: ICalendarQueryParams) => {
  if (!customerId || !queries.from || !queries.to) return
  queryClient.prefetchQuery(calendarQueryKeys.GET_GLOBAL_CALENDAR(customerId, { ...queries }), () =>
    fetcher<Array<ICalendarEvent>>(calendarEndpoints.globalCalendar(customerId), { ...queries }),
  )
}
